export class SelectedFilter {
  public FilterName: string;
  public FilterValueId: number;
  public FilterValueName: string;

  constructor(FilterName: string, FilterValueId: number, FilterValueName: string) {
    this.FilterName = FilterName;
    this.FilterValueId = FilterValueId;
    this.FilterValueName = FilterValueName;
  }
}
